import React, {useState,useEffect} from 'react'
import Header from 'components/Headers/Header'
import DatePicker from "react-datepicker"
import {salesByDate,salesByEmp,checkStock} from 'network/ApiAxiosMerchShop'
import UserByRoleDropdownSele from 'components/Reusable Components/UserByRoleDropdownSele'

import Report from '@weknow/react-data-report';
import { Button, Col, Input, Row } from 'reactstrap';
import Select from 'react-select';
import { allProds } from 'network/ApiAxiosMerchShop'
import { salesByProd } from 'network/ApiAxiosMerchShop'

function Reports() {
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(null);
    const [reportData, setReportData] = useState(null);
    const [staffBuyModal, setStaffBuyModal] = useState(false);
    const [minStock, setMinStock] = useState();
    const [prods, setprods] = useState([]);
    const [options, setOptions] = useState([]);

    useEffect(() => {
        retriveAllProds()
    }, []);

    const onChange = (dates) => {
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);
    };
    
    const sizeHandler =(size)=>{
        switch (size) {
            case 'XXL':
                return '2XL'
                break;
            case 'XXXL':
                return '3XL'
                break;
            case 'XXXXL':
                return '4XL'
                break;
            default:
                return size
                break;
        }
    }
    
    const handleSalesByDate=async()=>{
        if(startDate && endDate){
            const resp = await salesByDate(startDate,endDate)
            if(resp.data.success){
                resp.data.data.map((OrderItem)=>{
                    if(OrderItem.cart.includes(' XXL '))OrderItem.cart = OrderItem.cart.replace(' XXL ',' 2XL ')
                    if(OrderItem.cart.includes(' XXXL '))OrderItem.cart = OrderItem.cart.replace(' XXXL ',' 3XL ')
                    if(OrderItem.cart.includes(' XXXXL '))OrderItem.cart = OrderItem.cart.replace(' XXXXL ',' 4XL ')
                })
                setReportData(resp.data.data)
            }
        } 
    }

    const handleSalesByStaff =async(e)=>{
        const userID = JSON.parse(e)._id
        if(userID){
            const resp = await salesByEmp(userID)
            if(resp.data.success){
                resp.data.data.map((OrderItem)=>{
                    if(OrderItem.cart.includes(' XXL '))OrderItem.cart = OrderItem.cart.replace(' XXL ',' 2XL ')
                    if(OrderItem.cart.includes(' XXXL '))OrderItem.cart = OrderItem.cart.replace(' XXXL ',' 3XL ')
                    if(OrderItem.cart.includes(' XXXXL '))OrderItem.cart = OrderItem.cart.replace(' XXXXL ',' 4XL ')
                })
                setReportData(resp.data.data)
            }
        } 
    }

    const handleCheckStock =async()=>{
        if(minStock){
            const resp = await checkStock(minStock)
            if(resp.data.success){
                resp.data.data.map((OrderItem)=>{
                    if(OrderItem.product.includes(' XXL '))OrderItem.product = OrderItem.product.replace(' XXL ',' 2XL ')
                    if(OrderItem.product.includes(' XXXL '))OrderItem.product = OrderItem.product.replace(' XXXL ',' 3XL ')
                    if(OrderItem.product.includes(' XXXXL '))OrderItem.product = OrderItem.product.replace(' XXXXL ',' 4XL ')
                })
                setReportData(resp.data.data)
            }
        }
    }

    const retriveAllProds= async()=>{
        const resp = await allProds()
        const opts = resp.data.map((prodItem)=>{
            return {label:prodItem.house + ' ' + prodItem.desc + ' ' + prodItem.size + ' ' + prodItem.color, value: prodItem._id}
            })
        setOptions(opts)
    }

    const handleSelectedProd = async (prodId)=>{
        console.log('asasafff',prodId)
        const resp = await salesByProd(prodId)
        if(resp.data.success){
            setReportData(resp.data.data)
        }
    }

  return (
    <div>
        <Header/>
        <Row className='mr-4 mt--6 ml-4 mb-4 d-flex justify-content-center middle'>
            <Col className='text-center '>
                <h1>Sales By Date</h1>
                <DatePicker
                    selected={startDate}
                    onChange={onChange}
                    startDate={startDate}
                    endDate={endDate}
                    selectsRange
                    inline
                    calendarStartDay={1}
                    dateFormat="dd/MM/yyyy"
                />
                <Button onClick={()=>handleSalesByDate()}>Get Report</Button>
            </Col>
            <Col className='text-center '>
                <h1>Sales By Employee</h1>
                <UserByRoleDropdownSele modal={staffBuyModal} toggle={setStaffBuyModal} handler={handleSalesByStaff}/>
                <Button onClick={()=>setStaffBuyModal(!staffBuyModal)}>Get Report</Button>
            </Col>
            <Col className='text-center '>
                <h1>Sales By Product</h1>
                <Select onChange={(e)=>handleSelectedProd(e.value)} options={options} />
            </Col>
            <Col className='text-center '>
                <h1>Prods under stock</h1>
                <Input type='number' className='mb-2' onChange={(e)=> setMinStock(e.target.value)}></Input>
                <Button onClick={()=>handleCheckStock()}>Get Report</Button>
            </Col>
        </Row>
        <hr/>
        
        {reportData && <Report data={ reportData}  opening={(<h1>Merchandise Shop Report {new Date().toDateString()}.</h1>)}/>}
    </div>
  )
}

export default Reports